//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Location from "./Location.vue";
import LocationSearch from "./LocationSearch.vue";
import { FocusTrap } from "focus-trap-vue";
import map from "lodash-es/map";
import sortBy from "lodash-es/sortBy";
import Vue from "vue";
import dayjs from "dayjs";

export default {
  components: {
    Location,
    LocationSearch,
    FocusTrap,
  },
  data: () => ({
    state: {
      locations: {
        open: false,
        loading: false,
        loaded: false,
      },
      maps: {
        loaded: false,
      },
    },
    allLocationsClosed: false,
    postsCache: [],
    posts: [],
    coords: [],
    matrices: [],
    userLocation: { lat: false, lng: false },
  }),
  props: ["open", "maps-loaded"],
  mounted() {
    this.getClosures();
    this.events();
  },

  methods: {
    events() {
      window.PubSub.subscribe("document:keyup", (name, { which }) => {
        if (which == 27 && this.open) {
          this.close();
        }
      });

      /**
       * Simple check that Google Maps JS API is loaded.
       */
      window.PubSub.subscribe("maps:loaded", () => {
        this.state.maps.loaded = true;
      });

      /**
       * Forces our locations to load only one time when the slide-out is opened for the first tim.e
       */
      let token = window.PubSub.subscribe("locations:show", () => {
        if (!this.state.locations.loaded) {
          this.load();

          window.PubSub.unsubscribe(token);
        }
      });

      /**
       * Fires when the user gives their location via geolocation APIs in their browser,
       * OR a geocode request is returned.
       */
      window.PubSub.subscribe("user:location", (name, { lat, lng }) => {
        this.userLocation.lat = lat;
        this.userLocation.lng = lng;

        this.getLocationDistances.call(this);
      });
    },
    getClosures() {
      if (!window.Locations || !window.Locations.closures) {
        return;
      }

      let now = dayjs();
      let closures = window.Locations.closures;

      closures.forEach(
        function (day) {
          let then = dayjs(day);

          if (now.isSame(then, "day")) {
            this.allLocationsClosed = true;

            return;
          }
        }.bind(this)
      );
    },

    handleAppFocus() {
      console.log(`Focus!`);
    },
    /**
     * Get all of our locations from the WordPress API.
     */
    load() {
      this.state.locations.loading = true;

      $.getJSON("/wp-json/wp/v2/location", {
        per_page: 25,
        orderby: "menu_order",
        order: "asc",
      })
        .done(this.done)
        .fail(this.fail)
        .always(() => {
          this.state.locations.loading = false;
          this.state.locations.loaded = false;
        });
    },
    /**
     * Successful response from WordPress endpoint.
     */
    done(response) {
      let coords = map(response, function (p) {
        return new gm.LatLng(p.meta.address.lat, p.meta.address.lng);
      });

      this.posts = response;
      this.postsCache = response;
      this.coords = coords;
      this.loaded = true;
    },

    /**
     * Fail response from the WordPress endpoint.
     */
    fail(response) {
      console.error("[Marden's] - Locations failed to load");
    },

    close() {
      window.PubSub.publish("locations:hide");

      this.state.locations.closed = true;
    },

    /**
     * Get all of our locations from Google's Distance Matrix Service.
     */
    getLocationDistances() {
      let origin = new gm.LatLng(this.userLocation.lat, this.userLocation.lng);
      let destinations = this.coords;
      let service = new gm.DistanceMatrixService();

      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations,
          travelMode: "DRIVING",
          unitSystem: gm.UnitSystem.IMPERIAL,
        },

        this.setLocationDistances.bind(this)
      );
    },

    /**
     * Sets and sorts response from Google's API via the Distance Matrix Service
     */
    setLocationDistances(response, status) {
      // No results
      if (!response.rows || response.rows.length === 0) {
        return;
      }

      let elements = response.rows[0].elements;
      let posts = [];

      Vue.set(this, "posts", []);

      /**
       * `elements` is in the same row as the destinations we've provided to the service.
       * Since we are sending coords in the same order as the `posts` data in the Vue
       * instance, we can safely set our matrix information per location by looping
       * through the elements as they are returned from Google.
       */
      elements.forEach((el, index) => {
        let p = this.postsCache[index];

        p.matrix = el;

        posts.push(p);
      });

      posts = sortBy(posts, (p) => p.matrix.distance.value);

      setTimeout(() => (this.posts = posts), 10);
    },
  },
  watch: {
    open() {
      this.state.locations.open = this.open;
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/components/Locations.vue